import eventCapabilities from "./event_capabilities_queued.js"

function addKeyBinderEventsCapabilities (keyBinder) {
    eventCapabilities(keyBinder)
    setListeners(keyBinder)

    let oldClear = keyBinder.clear
    keyBinder.clear = function () {
        oldClear()
        setListeners(keyBinder)
    }

    let oldUnbind = keyBinder.unbind
    keyBinder.unbind = function (keys, handler) {
        oldUnbind(keys, handler)
        if (keys === "*") {
            setListeners(keyBinder)
        }
    }
}


function setListeners (keyBinder) {
    keyBinder.onPressed("*", function (event) {
        let key = formatKey(event.key)
        keyBinder.emit(`${key} pressed`)
        keyBinder.emit("key pressed", key)
    })

    keyBinder.onReleased("*", function (event) {
        let key = formatKey(event.key)
        keyBinder.emit(key)
        keyBinder.emit(`${key} released`)
        keyBinder.emit("key released", key)
    })
}


function formatKey (key) {
    return key.replace("Arrow", "").toLowerCase()
}


export default addKeyBinderEventsCapabilities
